import { models, patients } from '@zipdrug/react-api-sdk';
import { alertOnError } from '@zipdrug/ui';
import { graphql } from 'react-apollo';
import React, { useState, useCallback } from 'react';
import withRefreshPatients from '../../../hoc/withRefreshPatients';
import LanguageMenu from './LanguageMenu';

const LanguageMenuContainer = props => {
  const [isEditing, setIsEditing] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const languageOptions = Object.keys(models.LanguageType);

  const onToggleEdit = useCallback(() => setIsEditing(editing => !editing), []);
  const onSelectLanguage = useCallback(language => setSelectedLanguage(language), []);

  const onSubmit = useCallback(async () => {
    const { mutateUpdatePatient, onRefetchPatients, patient } = props;
    return alertOnError(
      mutateUpdatePatient({
        variables: {
          id: patient.id,
          modifier: {
            language: models.LanguageType[selectedLanguage],
          },
        },
      }),
    )
      .then(onRefetchPatients)
      .then(onToggleEdit);
  }, [props, selectedLanguage, onToggleEdit]);

  return (
    <LanguageMenu
      {...props}
      isEditing={isEditing}
      onToggleEdit={onToggleEdit}
      selectedLanguage={selectedLanguage}
      onSelectLanguage={onSelectLanguage}
      onSubmit={onSubmit}
      languageOptions={languageOptions}
    />
  );
};

export default graphql(patients.mutateUpdatePatient, { name: 'mutateUpdatePatient' })(
  withRefreshPatients(LanguageMenuContainer),
);
